import React from "react";
import PrivacyCustomHeading from "../other/common/PrivacyCustomHeading";

const PrivacySecurityText = () => {
  return (
    <>
      <div className="py-[140px] max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10 px-4">
        <div className="max-w-[768px] mx-auto">
          <PrivacyCustomHeading text="Privacy Settings" />
          <p className="text-base text-[#5E5C5C]">
            At{" "}
            <span className="text-[#010101] font-bold mt-4">
              {" "}
              Makeway India,
            </span>{" "}
            your privacy is our priority. We believe in transparency and giving
            you full control over how your data is used. Below are the ways you
            can manage and personalize your privacy settings:
          </p>
          <div className="my-10">
            <PrivacyCustomHeading text="Communication Preferences" />
            <ol className="mt-4 list-decimal list-inside">
              <li className="text-base text-[#5E5C5C]">
                <span className="font-bold text-[#010101]">
                  Stay Connected on Your Terms:
                </span>
                Choose to subscribe or unsubscribe from wellness updates,
                product news, and special offers.
              </li>
              <li className="mt-4">
                <span className="font-bold text-[#010101]">
                  Select Your Preferred Channel:
                </span>
                Decide how you'd like to hear from us—Email, SMS, or Call..
              </li>
            </ol>
          </div>
          <div className="">
            <PrivacyCustomHeading text="Data Access & Control" />
            <ol className="mt-4 list-decimal list-inside">
              <li className="text-base text-[#5E5C5C] mt-4">
                <span className="font-bold text-[#010101]">
                  Review Your Information:
                </span>
                Access and view the personal details we have stored.
              </li>
              <li className="my-4 text-base text-[#5E5C5C]">
                <span className="font-bold text-[#010101]">
                  Edit with Ease:
                </span>
                Update or correct your information at any time.
              </li>
              <li className="text-base text-[#5E5C5C]">
                <span className="font-bold text-[#010101]">
                  Delete Your Data:
                </span>
                You may request complete removal of your personal data from our
                systems.
              </li>
            </ol>
          </div>
          <div className="my-10">
            <PrivacyCustomHeading text="Cookies & Tracking Preferences" />
            <ol className="mt-4 list-decimal list-inside">
              <li className="text-base text-[#5E5C5C] mt-4">
                <span className="font-bold text-[#010101]">
                  Control Your Experience:
                </span>
                Accept or reject tracking cookies based on your comfort.
              </li>
              <li className="my-4 text-base text-[#5E5C5C]">
                <span className="font-bold text-[#010101]">
                  Customize Settings:
                </span>
                Tailor your cookie preferences via our easy-to-use cookie
                banner.
              </li>
            </ol>
          </div>
          <div className="my-10">
            <PrivacyCustomHeading text="Control Your Experience:" />
            <p className="text-base text-[#5E5C5C] mt-4">
              <span className="font-bold text-[#010101] ">
                Take Your Data With You:
              </span>{" "}
              You can request a downloadable, machine-readable copy of your
              personal information at any time.
            </p>
          </div>
          <div className="">
            <PrivacyCustomHeading
              text="Manage Your Privacy Settings Anytime:"
              myClass="pb-4"
            />
            <a href="/" className="text-base text-[#5E5C5C] leading-[150%]">
              Visit &nbsp;
              <span className="text-[#0579E1] border-b border-[#0579E1]">
                www.makewayindia.com/privacy-settings
              </span>
              &nbsp; to customize your experience.
            </a>
          </div>
        </div>
      </div>
      <div className="h-[210px]"></div>
    </>
  );
};

export default PrivacySecurityText;
